import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserService } from "../core/user.service";
import { AuthService } from "../core/auth.service";
import { ItemEvent, Photos, questions } from "../models/evidence";
import * as Moment from "moment";

interface itemsConfigObj {
  name: string;
  rows: itemsConfigDetails[];
}

interface itemsConfigDetails {
  id?: number;
  title: string;
  nextScreen: string;
  url_icon: string;
  questionary_id?: number;
  isExtraItem?: boolean;
  isDeleted?: boolean;
}

interface ordenes_pdf {
  id: string;
  order_number: string;
  customer_name: string;
  order_name: string;
  address: string;
  users_all: boolean;
  start_date: string;
  end_date: string;
  latitude: string;
  longitude: string;
  users: any[];
  status: string; //1 -> pendiente, 2 -> proceso, 3 -> completado
  user_uid: string;
  user_name: string;
  geolocation: any;
  address_checkIn?: string;
  evidence: ItemEvent[];
  photo_evidence: Photos[];
}

export interface PhotosTmp {
  item_evidence_id: string;
  photo_name: string;
  thumb_name: string;
  url_photo: string;
  url_thumb: string;
}

export interface SignaturesTmp {
  item_evidence_id: string;
  signature_name: string;
  signed_customer_name?: string;
  url: string;
}

interface MultiPhotosObj {
  id: string;
  title: string;
  descripcion: string;
  evidencia: Photos[];
}

interface PreguntasObj {
  id?: number;
  title: string;
  questions: questions[];
}

interface itemsExtra {
  doc?: string;
  items_extra: itemsConfigDetails[];
}

interface SignaturesObj {
  id?: string;
  title: string;
  firmas: SignaturesTmp[];
}

@Component({
  selector: "app-generate-pdf",
  templateUrl: "./generate-pdf.component.html",
  styleUrls: ["./generate-pdf.component.scss"],
})
export class GeneratePdfComponent implements OnInit {
  sub;
  url_map = "";
  url_link = "";
  url_logo_client = "";

  order_pdf: ordenes_pdf = {
    id: "",
    order_number: "",
    customer_name: "",
    order_name: "",
    address: "",
    users_all: false,
    start_date: "",
    end_date: "",
    latitude: "",
    longitude: "",
    users: [],
    status: "", //1 -> pendiente, 2 -> proceso, 3 -> completado
    user_uid: "",
    user_name: "",
    geolocation: null,
    address_checkIn: "",
    evidence: [],
    photo_evidence: [],
  };

  //public items_config: itemsConfigObj = null;
  public items_config: itemsConfigDetails[] = [];
  list_photos: PhotosTmp[] = [];
  list_signatures: SignaturesTmp[] = [];
  array_questionaries: PreguntasObj[] = [];
  array_comments: PreguntasObj[] = [];
  array_evidence: MultiPhotosObj[] = [];
  array_signatures: SignaturesObj[] = [];

  //template_pdf = '<HTML> <HEAD> <META charset=UTF-8"> <TITLE></TITLE> <STYLE type="text/css"> html {zoom: 0.64; font-family: Arial, Helvetica, sans-serif;}  body { height:100vh; margin-top: 0px;margin-left: 0px; font-family: Arial, Helvetica, sans-serif;} #page {position:relative; overflow: hidden;margin: 22px 0px 20px 17px;padding: 0px;border: none;width: 799px;height: auto;} #page #img_logo {width:auto;height: 100px;} #line { border: 1px solid #9FAFC1; margin-top: 30px;} h2 { font-size: 2.0em; color: #3B4754; margin-bottom: 4px !important; } #s_order { color: #9FAFC1} #icons_report { margin-right: 15px;}  .toolboxItems{ 	margin-top: 50px;  	margin-bottom:20px; }  .toolboxItems .image, .toolboxItems .label {   display: table-cell;   width: 25px;   vertical-align: middle;   padding: 0px; }  .toolboxItems .label {   width: 100%;   color: #3B4754;   font-size: 1.2em; } /* .toolboxItems .label_description {   width: 100%;   color: #3B4754;   font-size: 1.2em;   margin-left:15px; } */ .toolboxItems .image_items {   display: table-cell;   width: auto;   vertical-align: middle;   padding: 5px;   margin-left: 10px;   background-color: #F45B69;   border-radius: 10px; }  .toolboxItems_2{ 	margin-top: 20px; }  .toolboxItems_2 .image, .toolboxItems_2 .label {   display: inline-block;   width: 25px;   vertical-align: middle;   padding: 0px; }  .toolboxItems_2 .label {   width: 190px;   color: #3B4754;   font-size: 1.2em; }  .lbl_questions{  	font-size: 1.0em;  	color: #3B4754; } </STYLE> </HEAD>  	<BODY> 		<DIV id="page"> 			<TABLE style="width:100%"> 			<TR> 				<TD> 					<DIV> 				 				            						{16} 					</DIV>  				</TD>	 				<TD style="text-align: right;"> 					<DIV> 				 				            						<img src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flogo.svg?alt=media&token=bf283e6d-29fd-437f-a156-ff6a7acc09f4" id="img_logo"> 					</DIV>  				</TD>	 			</TR> 		</TABLE> 			<HR id="line"> 			 <TABLE style="width:100%; padding:10px"> 			  <TR> 				<td width="50%"> 					<h2>{10}</h2> 					<span id="s_order">No de Orden:{0}</span> 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fcalendar.svg?alt=media&token=95c3ce70-330a-46e0-9c21-7149b8a3d2f6" alt="" />				   						</div>  						<div class="label"> 						   <label><b>{14}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fclock.svg?alt=media&token=157af8d0-4e0b-4a22-8222-25cbab896ad7" alt="" />				   						</div>  						<div class="label"> 						   <label><b>Check In:  <nobr>{3}</nobr></b></label> 						   <label><b>Check Out: {4}</b></label>                <label><b>Duration: {15}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flocation.svg?alt=media&token=8b152ff7-fabc-4753-b1b3-033d4195d83b" alt="" />				   						</div>  						<div class="label"> 						   <label><b>{11}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fuser.svg?alt=media&token=6068a6d4-5030-4022-b4e8-bba01428a5e8" alt="" />				   						</div>  						<div class="label"> 						   <label><b>Username {12}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 						</div>  						<div class="label"> 						   <label><b>URL: {17}</b></label> 						</div> 					</div> 					 					 				</td> 				<td width="50%"> 					{13} 				</td> 			  </TR> 			</TABLE>  			<HR id="line"> 			 			{6} 			 			 		</DIV> 		 	</BODY> </HTML>';
  template_pdf =
    '<HTML> <HEAD> <META charset=UTF-8"> <TITLE></TITLE> <STYLE type="text/css"> .break-before {page-break-before: always;} .no-break {page-break-inside: avoid;} .clearfix:after {content: " "; visibility: hidden; display: block; height: 0; clear: both;} html {zoom: 0.64; font-family: Arial, Helvetica, sans-serif;}  body { height:100vh; margin-top: 0px;margin-left: 0px; font-family: Arial, Helvetica, sans-serif;} #page {position:relative; overflow: hidden;margin: 22px 0px 20px 17px;padding: 0px;border: none;width: 799px;height: auto;} #page #img_logo {width:auto;height: 100px;} #line { border: 1px solid #9FAFC1; margin-top: 30px;} h2 { font-size: 2.0em; color: #3B4754; margin-bottom: 4px !important; } #s_order { color: #9FAFC1} #icons_report { margin-right: 15px;}  .toolboxItems{ 	margin-top: 50px;  	margin-bottom:20px; }  .toolboxItems .image, .toolboxItems .label {   display: table-cell;   width: 25px;   vertical-align: middle;   padding: 0px; }  .toolboxItems .label {   width: 100%;   color: #3B4754;   font-size: 1.2em; } /* .toolboxItems .label_description {   width: 100%;   color: #3B4754;   font-size: 1.2em;   margin-left:15px; } */ .toolboxItems .image_items {   display: table-cell;   width: auto;   vertical-align: middle;   padding: 5px;   margin-left: 10px;   background-color: #F45B69;   border-radius: 10px; }  .toolboxItems_2{ 	margin-top: 20px; }  .toolboxItems_2 .image, .toolboxItems_2 .label {   display: inline-block;   width: 25px;   vertical-align: middle;   padding: 0px; }  .toolboxItems_2 .label {   width: 190px;   color: #3B4754;   font-size: 1.2em; }  .lbl_questions{  	font-size: 1.0em;  	color: #3B4754; } </STYLE> </HEAD>  	<BODY> 		<DIV id="page"> 			<TABLE style="width:100%"> 			<TR> 				<TD> 					<DIV> 				 				            						{16} 					</DIV>  				</TD>	 				<TD style="text-align: right;"> 					<DIV> 				 				            						<img src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flogo.svg?alt=media&token=bf283e6d-29fd-437f-a156-ff6a7acc09f4" id="img_logo"> 					</DIV>  				</TD>	 			</TR> 		</TABLE> 			<HR id="break-before"> 			 <TABLE style="width:100%; padding:10px"> 			  <TR> 				<td width="50%"> 					<h2>{10}</h2> 					<span id="s_order">No de Orden:{0}</span> 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fcalendar.svg?alt=media&token=95c3ce70-330a-46e0-9c21-7149b8a3d2f6" alt="" />				   						</div>  						<div class="label"> 						   <label><b>{14}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fclock.svg?alt=media&token=157af8d0-4e0b-4a22-8222-25cbab896ad7" alt="" />				   						</div>  						<div class="label"> 						   <label><b>Check In:  <nobr>{3}</nobr></b></label> 						   <label><b>Check Out: {4}</b></label>                <label><b>Duration: {15}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Flocation.svg?alt=media&token=8b152ff7-fabc-4753-b1b3-033d4195d83b" alt="" />				   						</div>  						<div class="label"> 						   <label><b>{11}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems"> 						<div class="image"> 							<img id="icons_report" width="25" height="25" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Freport_icons%2Fuser.svg?alt=media&token=6068a6d4-5030-4022-b4e8-bba01428a5e8" alt="" />				   						</div>  						<div class="label"> 						   <label><b>Username {12}</b></label> 						</div> 					</div> 					 					<div class="toolboxItems_2"> 						<div class="image"> 						</div>  						<div class="label"> 						   <label><b>URL: {17}</b></label> 						</div> 					</div> 					 					 				</td> 				<td width="50%"> 					{13} 				</td> 			  </TR> 			</TABLE>  			<HR id="break-before"> 			 			{6} 			 			 		</DIV> 		 	</BODY> </HTML>';
  @Input() template: string = `<div></div>`;

  loading = true;

  constructor(
    private route: ActivatedRoute,
    public userService: UserService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe((params) => {
      if (this.authService.customer_route != "") {
        console.log("Si se conoce el cliente");
        this.userService.customerDB = this.authService.customerDB;
        this.userService.customerSelected = this.authService.customerSelected;
        console.log("PARAMS -> " + params);
        var order_uuid = params["order_uui"];
        this.goToPdf(order_uuid);
      }
    });
  }

  goToPdf(id: string) {
    console.log("Generar PDF...");
    this.list_photos = [];
    this.list_signatures = [];
    this.array_questionaries = [];
    this.array_evidence = [];

    this.userService.getInfoOrder(id).then((order_data: any) => {
      if (order_data != null) {
        this.order_pdf.id = order_data.firebase_id;
        this.order_pdf.order_number = order_data.order_number;
        this.order_pdf.customer_name = order_data.customer_name;
        this.order_pdf.order_name = order_data.order_name;
        this.order_pdf.address = order_data.address;
        this.order_pdf.users_all = order_data.users_all;
        this.order_pdf.start_date = order_data.start_date;
        this.order_pdf.end_date = order_data.end_date;
        this.order_pdf.latitude = order_data.latitude;
        this.order_pdf.longitude = order_data.longitude;
        this.order_pdf.users = order_data.users;
        this.order_pdf.status = order_data.status;
        this.order_pdf.user_uid = order_data.user_uid;
        this.order_pdf.user_name = order_data.user_name;
        this.order_pdf.geolocation = order_data.geolocation;
        this.order_pdf.address_checkIn = order_data.address_checkIn;

        //this.url_map = "https://maps.googleapis.com/maps/api/staticmap?center=" + this.order_pdf.latitude + "," + this.order_pdf.longitude + "&zoom=18&size=600x400&maptype=roadmap&markers=color:green|label:Site|" + this.order_pdf.latitude + "," + this.order_pdf.longitude + "&key=AIzaSyDPI_jYrXxcTGMmUKmSQQ0I021pBpzAZ4Q";
        this.url_map =
          '<img src= "https://maps.googleapis.com/maps/api/staticmap?center=' +
          this.order_pdf.latitude +
          "," +
          this.order_pdf.longitude +
          "&amp;zoom=18&amp;size=400x400&amp;maptype=roadmap&amp;markers=color:green|label:Site|" +
          this.order_pdf.latitude +
          "," +
          this.order_pdf.longitude +
          "&amp;key=AIzaSyDPI_jYrXxcTGMmUKmSQQ0I021pBpzAZ4Q" +
          '">';
        this.url_link =
          "http://trackpoint.dev.webpoint.com.mx/" +
          this.authService.customerSelected.name +
          "/detail-order?order_uui=" +
          id;
        //this.url_link = 'http://trackpoint.mx/' + this.authService.customerSelected.name + '/detail-order?order_uui=' + id;

        //this.url_logo_client = '<img src= "' + this.authService.customerSelected.url_logo + '" id="img_logo">';
        this.url_logo_client = this.authService.customerSelected.url_logo;

        this.loadEvidenOrder();
      } else {
        console.log("No se encontro la orden.");
      }
    });
  }

  loadEvidenOrder() {
    this.userService
      .getAllEvidenceByOrder(this.order_pdf.id)
      .then((evidencia: ItemEvent[]) => {
        if (evidencia.length > 0) {
          this.order_pdf.evidence = evidencia;

          this.userService
            .getItemsConfiguration()
            .then(() => {
              this.userService
                .getExtraItemsConfig(this.order_pdf.id)
                .then((extra_items: itemsExtra) => {
                  var items_rows_temp_1: itemsConfigDetails[] = [];
                  var items_rows_temp_2: itemsConfigDetails[] = [];

                  for (let obj1 of this.userService.items_config.rows) {
                    items_rows_temp_1.push({
                      id: obj1.id,
                      title: obj1.title,
                      nextScreen: obj1.nextScreen,
                      url_icon: obj1.url_icon,
                      questionary_id: obj1.questionary_id,
                      isExtraItem: false,
                      isDeleted: false,
                    });
                  }

                  for (let obj2 of extra_items.items_extra) {
                    if (obj2.isDeleted == false) {
                      items_rows_temp_2.push({
                        id: obj2.id,
                        title: obj2.title,
                        nextScreen: obj2.nextScreen,
                        url_icon: obj2.url_icon,
                        questionary_id: obj2.questionary_id,
                        isExtraItem: obj2.isExtraItem,
                        isDeleted: obj2.isDeleted,
                      });
                    }
                  }

                  /////////Descartar los items default, si se encuentran en los extra///////////////
                  for (let item_df of items_rows_temp_1) {
                    var obj = items_rows_temp_2.find(
                      (item) => item.id === item_df.id
                    );
                    if (obj == null) {
                      items_rows_temp_2.push(item_df);
                    }
                  }

                  this.items_config = items_rows_temp_2;
                  this.items_config = this.items_config.sort(
                    (n1, n2) => n1.id - n2.id
                  );
                  //////////////////////////////////////////////////////////////////////////////////

                  this.getAllUrlPhotosByOrder()
                    .then((res) => {
                      if (res) {
                        for (let item of this.order_pdf.evidence) {
                          if (item.photos.length > 0) {
                            if (item.itemId_assigned != undefined) {
                              if (item.itemId_assigned == 0) {
                                var photos: Photos[] = [];
                                for (let obj of this.list_photos) {
                                  if (item.id == obj.item_evidence_id) {
                                    photos.push({
                                      photo_name: obj.photo_name,
                                      thumb_name: obj.thumb_name,
                                      url_photo: obj.url_photo,
                                      url_thumb: obj.url_thumb,
                                    });
                                  }
                                }

                                this.array_evidence.push({
                                  id: item.id,
                                  title: "Foto Evidencia",
                                  descripcion: item.description,
                                  evidencia: photos,
                                });
                              } else {
                                for (let obj of this.items_config) {
                                  if (item.itemId_assigned == obj.id) {
                                    var photos: Photos[] = [];
                                    for (let obj of this.list_photos) {
                                      if (item.id == obj.item_evidence_id) {
                                        photos.push({
                                          photo_name: obj.photo_name,
                                          thumb_name: obj.thumb_name,
                                          url_photo: obj.url_photo,
                                          url_thumb: obj.url_thumb,
                                        });
                                      }
                                    }

                                    this.array_evidence.push({
                                      id: item.id,
                                      title: obj.title,
                                      descripcion: item.description,
                                      evidencia: photos,
                                    });
                                  }
                                }
                              }
                            } else {
                              var photos: Photos[] = [];
                              for (let obj of this.list_photos) {
                                if (item.id == obj.item_evidence_id) {
                                  photos.push({
                                    photo_name: obj.photo_name,
                                    thumb_name: obj.thumb_name,
                                    url_photo: obj.url_photo,
                                    url_thumb: obj.url_thumb,
                                  });
                                }
                              }

                              this.array_evidence.push({
                                id: item.id,
                                title: "Foto Evidencia",
                                descripcion: item.description,
                                evidencia: photos,
                              });
                            }
                          }
                        }

                        this.setSignatures();
                      }
                    })
                    .catch((err) => {
                      console.log("Error al obtener las photos.");
                    });
                })
                .catch((err1) => {
                  console.log("Err 1 -> " + err1);
                });
              //this.items_config = this.userService.items_config;
            })
            .catch((error) => {
              console.log("Error al obtener los items -> " + error);
            });
        } else {
          console.log("No se encontro evidencia para la orden.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /*
  loadEvidenOrder(){
    this.userService.getAllEvidenceByOrder(this.order_pdf.id).then((evidencia: ItemEvent[]) => {
      if(evidencia.length > 0){
        this.order_pdf.evidence = evidencia;

        this.userService.getItemsConfiguration().then(() => {
          this.items_config = this.userService.items_config;

          this.getAllUrlPhotosByOrder().then((res) => {
            if(res){
              for(let item of this.order_pdf.evidence){
                if(item.photos.length > 0){
                  var photos: Photos[] = [];
                  for(let obj of this.list_photos){
                    if(item.id == obj.item_evidence_id){
                      photos.push({photo_name: obj.photo_name, thumb_name: obj.thumb_name, url_photo: obj.url_photo, url_thumb: obj.url_thumb});
                    }
                  }
  
                  this.array_evidence.push({id: item.id, descripcion: item.description, evidencia: photos});
                }
              }
  
              this.setSignatures();
            }
          })
          .catch((err) => {
            console.log('Error al obtener las photos.');
          });
        })
        .catch((error) => {
          console.log('Error al obtener los items -> ' + error);
        });
        
      }
      else{
        console.log('No se encontro evidencia para la orden.');
      }
    })
    .catch((err) => {
      console.log(err);
    });
  }
  */
  setSignatures() {
    this.list_signatures = [];
    this.getAllUrlSignaturesByOrder()
      .then((res) => {
        if (res) {
          console.log("Firmas cargadas correctamente.");

          this.loadAllQuestionariesByOrder()
            .then((result) => {
              if (result) {
                console.log("Preguntas cargadas correctamente.");
                console.log(
                  "Preguntas -> " + JSON.stringify(this.array_questionaries)
                );

                this.loadAllCommentsByOrder()
                  .then((result) => {
                    if (result) {
                      console.log("Comentarios cargados correctamente.");
                      console.log(
                        "Comentarios -> " + JSON.stringify(this.array_comments)
                      );

                      this.preparePDF().then((ok) => {
                        if (ok) {
                          this.userService
                            .createNewReport(this.template)
                            .then((id_report) => {
                              console.log("Report ID -> " + id_report);
                              var url_customer =
                                this.authService.customerSelected.url_pdf;

                              const link = document.createElement("a");
                              //link.target = '_blank';
                              link.href =
                                url_customer + "?report_id=" + id_report;
                              link.setAttribute("visibility", "hidden");
                              link.click();
                              this.loading = false;
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }
                      });
                    }
                  })
                  .catch((err) => {
                    console.log("Error al obtener las preguntas. -> " + err);
                  });
              }
            })
            .catch((err) => {
              console.log("Error al obtener las preguntas. -> " + err);
            });
        }
      })
      .catch(() => {
        console.log("Error al obtener las photos.");
      });
  }

  getAllUrlPhotosByOrder() {
    return new Promise((resolve, reject) => {
      this.list_photos = [];
      var contador = 0;
      var num_photos = 0;

      for (let item of this.order_pdf.evidence) {
        if (item.photos.length > 0) {
          num_photos += item.photos.length;
        }
      }

      console.log("Total de fotos -> " + num_photos);

      for (let item of this.order_pdf.evidence) {
        if (item.photos.length > 0) {
          for (let photo of item.photos) {
            this.userService.customerDB.app
              .storage()
              .ref(
                this.order_pdf.user_uid +
                  "/orders/" +
                  this.order_pdf.id +
                  "/evidence/" +
                  item.id +
                  "/"
              )
              .child(photo.photo_name)
              .getDownloadURL()
              .then((URL) => {
                contador += 1;
                this.list_photos.push({
                  item_evidence_id: item.id,
                  photo_name: photo.photo_name,
                  thumb_name: photo.thumb_name,
                  url_photo: URL,
                  url_thumb: "",
                });

                if (contador == num_photos) {
                  resolve(true);
                }
              })
              .catch((err) => {
                console.log("Error al obtener foto url: " + err);
              });
          }
        }
      }
    });
  }

  getAllUrlSignaturesByOrder() {
    return new Promise((resolve, reject) => {
      var contador = 0;
      var num_firmas = 0;

      for (let item of this.order_pdf.evidence) {
        if (item.last_signed_name != "") {
          num_firmas += 1;
        }
      }

      console.log("Total de firmas -> " + num_firmas);
      if (num_firmas > 0) {
        this.array_signatures = [];
        for (let item of this.order_pdf.evidence) {
          if (item.last_signed_name != "") {
            console.log("Item Asignado -> " + item.itemId_assigned);
            if (item.itemId_assigned != undefined) {
              if (item.itemId_assigned == 0) {
                this.userService.customerDB.app
                  .storage()
                  .ref(
                    this.order_pdf.user_uid +
                      "/orders/" +
                      this.order_pdf.id +
                      "/evidence/" +
                      item.id +
                      "/"
                  )
                  .child(item.last_signed_name)
                  .getDownloadURL()
                  .then((URL) => {
                    contador += 1;
                    this.list_signatures.push({
                      item_evidence_id: item.id,
                      signature_name: item.last_signed_name,
                      signed_customer_name: item.last_signed_customer_name,
                      url: URL,
                    });

                    this.array_signatures.push({
                      title: "Firmas",
                      firmas: this.list_signatures,
                    });

                    if (contador == num_firmas) {
                      resolve(true);
                    }
                  })
                  .catch((err) => {
                    console.log("Error al obtener firma url: " + err);
                  });
              } else {
                for (let obj of this.items_config) {
                  if (item.itemId_assigned == obj.id) {
                    this.userService.customerDB.app
                      .storage()
                      .ref(
                        this.order_pdf.user_uid +
                          "/orders/" +
                          this.order_pdf.id +
                          "/evidence/" +
                          item.id +
                          "/"
                      )
                      .child(item.last_signed_name)
                      .getDownloadURL()
                      .then((URL) => {
                        contador += 1;
                        this.list_signatures.push({
                          item_evidence_id: item.id,
                          signature_name: item.last_signed_name,
                          signed_customer_name: item.last_signed_customer_name,
                          url: URL,
                        });

                        console.log(
                          "List Signatures -> " +
                            JSON.stringify(this.list_signatures)
                        );
                        this.array_signatures.push({
                          id: item.id,
                          title: obj.title,
                          firmas: this.list_signatures,
                        });
                        this.list_signatures = [];

                        if (contador == num_firmas) {
                          console.log(
                            "Array Signatures -> " +
                              JSON.stringify(this.array_signatures)
                          );
                          console.log("***End***");
                          resolve(true);
                        }
                      })
                      .catch((err) => {
                        console.log("Error al obtener firma url: " + err);
                      });
                  }
                }
              }
            } else {
              this.userService.customerDB.app
                .storage()
                .ref(
                  this.order_pdf.user_uid +
                    "/orders/" +
                    this.order_pdf.id +
                    "/evidence/" +
                    item.id +
                    "/"
                )
                .child(item.last_signed_name)
                .getDownloadURL()
                .then((URL) => {
                  contador += 1;
                  this.list_signatures.push({
                    item_evidence_id: item.id,
                    signature_name: item.last_signed_name,
                    signed_customer_name: item.last_signed_customer_name,
                    url: URL,
                  });

                  this.array_signatures.push({
                    title: "Firmas",
                    firmas: this.list_signatures,
                  });

                  if (contador == num_firmas) {
                    resolve(true);
                  }
                })
                .catch((err) => {
                  console.log("Error al obtener firma url: " + err);
                });
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  /*
  getAllUrlSignaturesByOrder(){
    return new Promise((resolve, reject) =>{
 
     this.list_signatures = [];
     var contador = 0;
     var num_firmas = 0;
 
     for(let item of this.order_pdf.evidence){
       if(item.last_signed_name != ''){
         num_firmas += 1;
       }
     }
 
     console.log('Total de firmas -> ' + num_firmas);
 
     for(let item of this.order_pdf.evidence){
       if(item.last_signed_name != ''){
        this.userService.customerDB.app.storage().ref(this.order_pdf.user_uid + '/orders/' + this.order_pdf.id + '/evidence/' + item.id + '/')
        .child(item.last_signed_name).getDownloadURL().then((URL) => {
    
          contador += 1;
          this.list_signatures.push({
              item_evidence_id: item.id,
              signature_name: item.last_signed_name,
              signed_customer_name: item.last_signed_customer_name,
              url: URL 
          });

          if(contador == num_firmas){
            resolve(true);
          }
        })
        .catch((err) => {
          console.log('Error al obtener firma url: ' + err);
        });
       }
     }
 
    });
     
  }
  */
  loadAllQuestionariesByOrder() {
    return new Promise((resolve, reject) => {
      var contador = 0;
      for (let item of this.order_pdf.evidence) {
        if (item.title == "") {
          if (item.questions.length > 0) {
            contador = contador + 1;
          }
        }
      }

      //console.log(JSON.stringify(this.order.evidence));
      if (contador > 0) {
        for (let item of this.order_pdf.evidence) {
          if (item.questions.length > 0) {
            if (item.itemId_assigned != undefined) {
              if (item.itemId_assigned == 0) {
                this.array_questionaries.push({
                  title: "Cuestionario",
                  questions: item.questions,
                });
                if (contador == this.array_questionaries.length) {
                  resolve(true);
                }
              } else {
                for (let obj of this.items_config) {
                  if (item.itemId_assigned == obj.id) {
                    if (item.title == "") {
                      this.array_questionaries.push({
                        id: obj.id,
                        title: obj.title,
                        questions: item.questions,
                      });
                      if (contador == this.array_questionaries.length) {
                        //ordenar ids de menor a mayor
                        this.array_questionaries =
                          this.array_questionaries.sort(
                            (n1, n2) => n1.id - n2.id
                          );
                        resolve(true);
                      }
                    }
                  }
                }
              }
            } else {
              this.array_questionaries.push({
                title: "Cuestionario",
                questions: item.questions,
              });
              resolve(true);
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  loadAllCommentsByOrder() {
    return new Promise((resolve, reject) => {
      var contador = 0;
      for (let item of this.order_pdf.evidence) {
        if (item.title == "COMENTARIOS") {
          if (item.questions.length > 0) {
            contador = contador + 1;
          }
        }
      }

      //console.log(JSON.stringify(this.order.evidence));
      if (contador > 0) {
        for (let item of this.order_pdf.evidence) {
          if (item.questions.length > 0) {
            if (item.itemId_assigned != undefined) {
              if (item.itemId_assigned == 0) {
                this.array_comments.push({
                  title: "Comentarios",
                  questions: item.questions,
                });
                if (contador == this.array_comments.length) {
                  resolve(true);
                }
              } else {
                for (let obj of this.items_config) {
                  if (item.itemId_assigned == obj.id) {
                    if (item.title == "COMENTARIOS") {
                      this.array_comments.push({
                        id: obj.id,
                        title: obj.title,
                        questions: item.questions,
                      });
                      if (contador == this.array_comments.length) {
                        //ordenar ids de menor a mayor
                        this.array_comments = this.array_comments.sort(
                          (n1, n2) => n1.id - n2.id
                        );
                        resolve(true);
                      }
                    }
                  }
                }
              }
            } else {
              this.array_comments.push({
                title: "Cuestionario",
                questions: item.questions,
              });
              resolve(true);
            }
          }
        }
      } else {
        resolve(true);
      }
    });
  }

  preparePDF() {
    return new Promise((resolve, reject) => {
      /*********************Pintar Fotos*********************/
      var template_evidencias = "";

      console.log("Numero de Albums -> " + JSON.stringify(this.array_evidence));

      /****************Pintar Preguntas *****************/
      if (this.array_questionaries.length > 0) {
        var template_questions = "";

        for (let album_questions of this.array_questionaries) {
          var header_div =
            '<div class="no-break clearfix">' +
            '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
            '   <div class="image_items">' +
            '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_done.png?alt=media&token=9501497d-a853-4943-8547-664fa60a352e" alt="" />' +
            "   </div>" +
            '   <div class="label" style="padding-left:10px;">' +
            "     <label>" +
            album_questions.title +
            "</label>" +
            "   </div>" +
            " </div>" +
            "</div>" +
            ' <TABLE style="width:100%; padding:10px">';

          var end_table_q = "</TABLE>" + '<HR id="line">';

          var filas_tmp: string = "";

          for (let x = 0; x < album_questions.questions.length; x++) {
            var _row = "";
            if (album_questions.questions[x].type == "check") {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (
              album_questions.questions[x].type == "input" ||
              album_questions.questions[x].type == "dropdown" ||
              album_questions.questions[x].type == "textarea"
            ) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (!album_questions.questions[x].isOpenQuestion) {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (album_questions.questions[x].isOpenQuestion) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            }

            filas_tmp = filas_tmp + _row;
          }

          template_questions =
            template_questions + header_div + filas_tmp + end_table_q;
        }

        template_evidencias = template_evidencias + template_questions;
      }

      if (this.array_evidence.length > 0) {
        for (let album of this.array_evidence) {
          var template_album = "";
          var table = "";

          var number_photos = album.evidencia.length;
          var filas = number_photos / 2;
          var number_rows = Math.ceil(filas);
          var number_cols_tot = number_rows * 2;
          var number_cols_empty = number_cols_tot - album.evidencia.length;

          var header_div =
            '<div class="break-before">' +
            '  <div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
            '    <div class="image_items">' +
            '       <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_insert_photo.png?alt=media&token=4b4ea0de-1c04-484e-9300-9e2a5a26fb34" alt="" />' +
            "    </div>" +
            '    <div class="label" style="padding-left:10px;">' +
            "      <label>" +
            album.title +
            "</label>" +
            "    </div>" +
            "  </div>" +
            ' <TABLE style="width:100%; padding:10px">';

          var end_table = "   </TABLE>" + '   <HR id="line"> ' + "</div>";

          //Obtener los td's con fotos
          var arr_tds = [];
          for (let x = 0; x < album.evidencia.length; x++) {
            var td =
              '<td width="50%">' +
              '  <img style = "width: 95%; object-fit: contain; " src = "' +
              album.evidencia[x].url_photo +
              '" id="evidence">' +
              "</td>";
            arr_tds.push(td);
          }

          //Obtener los td's vacios
          for (let y = 0; y < number_cols_empty; y++) {
            var td = '<td width="50%">' + "&nbsp;" + "</td>";
            arr_tds.push(td);
          }

          var cont = 0;

          for (let i = 0; i < arr_tds.length; i++) {
            var row = "";

            if (cont == 0) {
              row = row + "<tr>";
            }

            if (cont < 1) {
              row = row + arr_tds[i];
            }

            if (cont == 1) {
              row = row + arr_tds[i];
              row = row + "</tr>";
              cont = 0;
            } else {
              cont = cont + 1;
            }

            table = table + row;
          }

          template_album = header_div + table + end_table;

          template_evidencias = template_evidencias + template_album;
        } // End for

        console.log("FOTOS -> " + template_evidencias);
      }

      /*********************Pintar las firmas*********************/
      if (this.array_signatures.length > 0) {
        var isFirstSignature = true;
        for (let album_firma of this.array_signatures) {
          if (isFirstSignature) {
            var div_title_firmas =
              '<div class="break-before">' +
              '  <div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
              '     <div class="image_items">' +
              '       <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_firma.png?alt=media&token=6afce37f-c7d1-410d-95fa-aeb0ce3bd0fb" alt="" />' +
              "    </div>" +
              '    <div class="label" style="padding-left:10px;">' +
              "       <label>" +
              album_firma.title +
              "</label>" +
              "    </div>" +
              "  </div>" +
              "</div>";

            isFirstSignature = false;
          } else {
            var div_title_firmas =
              '<div class=".no-break">' +
              '  <div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
              '     <div class="image_items">' +
              '       <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_firma.png?alt=media&token=6afce37f-c7d1-410d-95fa-aeb0ce3bd0fb" alt="" />' +
              "    </div>" +
              '    <div class="label" style="padding-left:10px;">' +
              "       <label>" +
              album_firma.title +
              "</label>" +
              "    </div>" +
              "  </div>" +
              "</div>";
          }

          var start_table =
            '<div style="width:770px;">' +
            '<TABLE style="width:100%; table-layout: fixed;">';

          var end_table = "</TABLE>" + "</div>";
          //'<HR id="line">';

          var template_firmas = "";
          var table = "";

          var number_photos = album_firma.firmas.length;
          var filas = number_photos / 2;
          var number_rows = Math.ceil(filas);
          var number_cols_tot = number_rows * 2;
          var number_cols_empty = number_cols_tot - album_firma.firmas.length;

          //Obtener los td's con firmas
          var arr_tds = [];
          for (let x = 0; x < album_firma.firmas.length; x++) {
            var td =
              '<td width="45%" style="text-align: center; padding: 5px">' +
              '<img style="object-fit: contain; width: 90%; height: 50%;" src="' +
              album_firma.firmas[x].url +
              '" id="evidence">' +
              '<HR id="line">' +
              "</br><label>" +
              album_firma.firmas[x].signed_customer_name +
              "</label>" +
              "</td>";
            arr_tds.push(td);
          }

          //Obtener los td's vacios
          for (let y = 0; y < number_cols_empty; y++) {
            var td = '<td width="45%">' + "&nbsp;" + "</td>";
            arr_tds.push(td);
          }

          //Ajustar td y tr
          var cont = 0;
          for (let i = 0; i < arr_tds.length; i++) {
            var row = "";

            if (cont == 0) {
              row = row + "<tr>";
            }

            if (cont < 1) {
              row = row + arr_tds[i];
            }

            if (cont == 1) {
              row = row + arr_tds[i];
              row = row + "</tr>";
              cont = 0;
            } else {
              cont = cont + 1;
            }

            table = table + row;
          }

          template_firmas = div_title_firmas + start_table + table + end_table;
          template_evidencias = template_evidencias + template_firmas;
        }
      }

      /****************Pintar Comentarios *****************/
      if (this.array_comments.length > 0) {
        var template_questions = "";

        for (let album_questions of this.array_comments) {
          var header_div =
            '<div class="no-break clearfix">' +
            '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
            '   <div class="image_items">' +
            '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_drive.png?alt=media&token=313f61fa-f049-4114-b947-afaa9cd00e16" alt="" />' +
            "   </div>" +
            '   <div class="label" style="padding-left:10px;">' +
            "     <label>" +
            album_questions.title +
            "</label>" +
            "   </div>" +
            " </div>" +
            "</div>" +
            ' <TABLE style="width:100%; padding:10px">';

          var end_table_q = "</TABLE>" + '<HR id="line">';

          var filas_tmp: string = "";

          for (let x = 0; x < album_questions.questions.length; x++) {
            var _row = "";
            if (album_questions.questions[x].type == "check") {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (
              album_questions.questions[x].type == "input" ||
              album_questions.questions[x].type == "dropdown" ||
              album_questions.questions[x].type == "textarea"
            ) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (!album_questions.questions[x].isOpenQuestion) {
              var answer = "";
              if (album_questions.questions[x].checked) {
                answer = "Si";
              } else {
                answer = "No";
              }

              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                answer +
                "</label>" +
                "</td>" +
                "</tr>";
            } else if (album_questions.questions[x].isOpenQuestion) {
              _row =
                "<tr>" +
                '<td width="60%" style="padding-top:10px;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].text +
                "</label>" +
                "</td>" +
                '<td width="40%" style="padding-top:10px; text-align: end;">' +
                '<label class="lbl_questions">' +
                album_questions.questions[x].answer +
                "</label>" +
                "</td>" +
                "</tr>";
            }

            filas_tmp = filas_tmp + _row;
          }

          template_questions =
            template_questions + header_div + filas_tmp + end_table_q;
        }

        template_evidencias = template_evidencias + template_questions;
      }

      /**************************************************/
      var template_materiales = "";
      //console.log('Tabla materiales -> ' + template_materiales);
      console.log("Tabla evidencias -> " + template_evidencias);

      var html_template: string = this.template_pdf;
      console.log("HTML ACTUAL -> " + html_template);

      var fecha_arr = this.order_pdf.start_date.split(" ");
      var fecha = fecha_arr[0];
      var hi = fecha_arr[1];

      var fecha_end = this.order_pdf.end_date.split(" ");
      var he = fecha_end[1];

      console.log("ORDEN -> " + JSON.stringify(this.order_pdf));

      /* Replace Order number */
      html_template = html_template.replace("{0}", this.order_pdf.order_number);
      /* Replace Order Customer Name */
      html_template = html_template.replace(
        "{1}",
        this.order_pdf.customer_name
      );
      /* Replace Order Address */
      html_template = html_template.replace(
        "{2}",
        this.order_pdf.address_checkIn
      );
      /* Replace Order CheckIn Date */
      html_template = html_template.replace("{3}", hi);
      //html_template = html_template.replace(new RegExp('{3}', 'g'), this.order.start_date);
      /* Replace Order CheckOut Date */
      html_template = html_template.replace("{4}", he);
      /* Replace Order Materiales */
      html_template = html_template.replace("{5}", template_materiales);
      /* Replace Order Photo Evidence */
      html_template = html_template.replace("{6}", template_evidencias);

      //if(this.my_evidencia != undefined && this.my_evidencia != null){
      /* Replace Evidencia Description */
      //html_template = html_template.replace('{7}', this.my_evidencia.description);
      //}

      /* Replace Evidencia Firma */
      //html_template = html_template.replace('{8}', this.url_firma);
      /* Replace Nombre del firmante */
      //html_template = html_template.replace('{9}', this.customer_name_signature);
      /* Replace Nombre de la orden o actividad */
      html_template = html_template.replace("{10}", this.order_pdf.order_name);
      /* Replace Address CheckIn */
      html_template = html_template.replace(
        "{11}",
        this.order_pdf.address_checkIn
      );
      /* Replace Usuario */
      html_template = html_template.replace("{12}", this.order_pdf.user_name);
      /* Replace URL MAP */
      html_template = html_template.replace("{13}", this.url_map);
      /* Replace Fecha */
      html_template = html_template.replace("{14}", fecha);
      /* Replace Order Duration */
      html_template = html_template.replace(
        "{15}",
        this.toDuration(this.order_pdf.start_date, this.order_pdf.end_date)
      );
      /* Replace Logo Client */
      var logo = '<img src= "' + this.url_logo_client + '" id="img_logo">';
      html_template = html_template.replace("{16}", logo);
      /* Replace URL_PDF */
      html_template = html_template.replace("{17}", this.url_link);

      this.template = html_template;
      /*
        this.template = this.FormatString(html_template, this.order.order_number, this.order.customer_name, this.order.address,
          this.order.start_date, this.order.end_date, template_materiales, template_evidencias, this.my_evidencia.description,
          this.url_firma, this.customer_name_signature, this.order.order_name, this.order.address, this.order.user_uid,
          this.url_map);
      */
      console.log("NEW TEMPLATE PDF -> " + this.template);

      resolve(true);
    });
  }

  /*
  preparePDF(){
    return new Promise((resolve, reject) => {
      //Pintar Fotos//
      var template_evidencias = '';

      console.log('Numero de Albums -> ' + JSON.stringify(this.array_evidence));

      if(this.array_evidence.length > 0){
        for(let album of this.array_evidence){
          var template_album = '';
          var table = '';

          var number_photos = album.evidencia.length;
          var filas = number_photos / 2;
          var number_rows = Math.ceil(filas);
          var number_cols_tot = number_rows * 2;
          var number_cols_empty = number_cols_tot - album.evidencia.length;

          var header_div = '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
                           '   <div class="image_items">' +
                           '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_insert_photo.png?alt=media&token=4b4ea0de-1c04-484e-9300-9e2a5a26fb34" alt="" />' +
                           '   </div>' +
                      
                           '   <div class="label" style="padding-left:10px;">' +
                           '     <label>' + album.descripcion + '</label>' +
                           '   </div>' +
                           ' </div>' +
                            
                           ' <TABLE style="width:100%; padding:10px">';

          var end_table = '</TABLE>' +
                          '<HR id="line"> ';                  

          //Obtener los td's con fotos
          var arr_tds = []; 
          for(let x=0; x < album.evidencia.length; x++){
            var td = '<td width="50%">' +
                     '  <img style = "width: 95%; object-fit: contain; " src = "' + album.evidencia[x].url_photo + '" id="evidence">' +
                     '</td>';
            arr_tds.push(td);
          }  

           //Obtener los td's vacios
          for(let y=0; y < number_cols_empty; y++){
            var td = '<td width="50%">' +
                        '&nbsp;' +
                    '</td>';
            arr_tds.push(td);
          }

          var cont = 0;

          for(let i = 0; i < arr_tds.length; i++){

            var row = '';

            if(cont == 0){
              row = row + '<tr>';
            }

            if(cont < 1){
              row = row + arr_tds[i];
            }

            if(cont == 1){
              row = row + arr_tds[i];
              row = row + '</tr>';
              cont = 0;
            }else{
              cont = cont + 1;
            }
            
            table = table + row;
          }

          template_album = header_div + table + end_table;

          template_evidencias = template_evidencias + template_album;
        }// End for

        console.log('FOTOS -> ' + template_evidencias);
      }

      //Pintar las firmas//
      if(this.list_signatures.length > 0){

        var div_title_firmas = '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
                               '   <div class="image_items">' +
                               '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_firma.png?alt=media&token=6afce37f-c7d1-410d-95fa-aeb0ce3bd0fb" alt="" />' +	
                               '  </div>' +

                               '   <div class="label" style="padding-left:10px;">' +
                               '     <label> Firmas </label>' +
                               '   </div>' +
                               ' </div>';

        var start_table = '<TABLE style="width:100%; padding:10px">';

        var end_table = '</TABLE>' +
                        '<HR id="line">'; 

          var template_firmas = '';
          var table = '';

          var number_photos = this.list_signatures.length;
          var filas = number_photos / 2;
          var number_rows = Math.ceil(filas);
          var number_cols_tot = number_rows * 2;
          var number_cols_empty = number_cols_tot - this.list_signatures.length;

           //Obtener los td's con firmas
           var arr_tds = []; 
           for(let x=0; x < this.list_signatures.length; x++){
             var td = '<td width="50%" style="text-align: center;">' +
                         '<img style="object-fit: contain;" src="' + this.list_signatures[x].url + '" id="evidence">' +
                         '<HR id="line">' +
						             '<label>' + this.list_signatures[x].signed_customer_name + '</label>' +
                     '</td>';
             arr_tds.push(td);
           }  
 
            //Obtener los td's vacios
           for(let y=0; y < number_cols_empty; y++){
             var td = '<td width="50%">' +
                         '&nbsp;' +
                     '</td>';
             arr_tds.push(td);
           }

           //Ajustar td y tr
          var cont = 0;
          for(let i = 0; i < arr_tds.length; i++){

            var row = '';

            if(cont == 0){
              row = row + '<tr>';
            }

            if(cont < 1){
              row = row + arr_tds[i];
            }

            if(cont == 1){
              row = row + arr_tds[i];
              row = row + '</tr>';
              cont = 0;
            }else{
              cont = cont + 1;
            }
            
            table = table + row;
          }
        
          template_firmas = div_title_firmas + start_table + table + end_table;
          template_evidencias = template_evidencias + template_firmas;
      }

       //Pintar Preguntas//
       if(this.array_questionaries.length > 0){

        var template_questions = '';

        for(let album_questions of this.array_questionaries){
          
          var header_div = '<div class="toolboxItems" style="margin-top:20px;margin-bottom:40px">' +
                           '   <div class="image_items">' +
                           '     <img width="40" height="40" src="https://firebasestorage.googleapis.com/v0/b/trackpoint-demos.appspot.com/o/icons_default%2Ficons_default_done.png?alt=media&token=9501497d-a853-4943-8547-664fa60a352e" alt="" />' +	
                           '   </div>' +
                      
                           '   <div class="label" style="padding-left:10px;">' +
                           '     <label>' + album_questions.title + '</label>' +
                           '   </div>' +
                           ' </div>' +
                            
                           ' <TABLE style="width:100%; padding:10px">';

          var end_table_q = '</TABLE>' +
                            '<HR id="line">';                  

          var filas_tmp: string = '';

          for(let x=0; x < album_questions.questions.length; x++){
            var _row = '';
                if(album_questions.questions[x].type == 'check'){
                  var answer = '';
                  if(album_questions.questions[x].checked){
                    answer = 'Si';
                  } else{
                    answer = 'No';
                  }

                  _row = '<tr>' +
                           '<td width="90%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + album_questions.questions[x].text + '</label>' +
                           '</td>' +
                           '<td width="10%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + answer + '</label>' +
                           '</td>' +  
                         '</tr>';

                }else if(album_questions.questions[x].type == 'input' || album_questions.questions[x].type == 'dropdown' || album_questions.questions[x].type == 'textarea'){

                  _row = '<tr>' +
                           '<td width="90%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + album_questions.questions[x].text + '</label>' +
                           '</td>' +
                           '<td width="10%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + album_questions.questions[x].answer + '</label>' +
                           '</td>' +  
                         '</tr>';

                }else if(!album_questions.questions[x].isOpenQuestion){

                  var answer = '';
                  if(album_questions.questions[x].checked){
                    answer = 'Si';
                  } else{
                    answer = 'No';
                  }

                  _row = '<tr>' +
                           '<td width="90%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + album_questions.questions[x].text + '</label>' +
                           '</td>' +
                           '<td width="10%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + answer + '</label>' +
                           '</td>' +  
                         '</tr>';
                
                }else if(album_questions.questions[x].isOpenQuestion){
                  _row = '<tr>' +
                           '<td width="90%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + album_questions.questions[x].text + '</label>' +
                           '</td>' +
                           '<td width="10%" style="padding-top:10px;">' +
                             '<label class="lbl_questions">' + album_questions.questions[x].answer + '</label>' +
                           '</td>' +  
                         '</tr>';
                }
                  
              
              filas_tmp = filas_tmp + _row;
          }

          template_questions = template_questions + header_div + filas_tmp + end_table_q;
        }

        template_evidencias = template_evidencias + template_questions;
      }

      ////////////////////////////////////////////////////////
      var template_materiales = '';
      //console.log('Tabla materiales -> ' + template_materiales);
      console.log('Tabla evidencias -> ' + template_evidencias);

      var html_template: string = this.template_pdf;
      console.log('HTML ACTUAL -> ' + html_template);

      var fecha_arr = this.order_pdf.start_date.split(' ');
      var fecha = fecha_arr[0];
      var hi = fecha_arr[1];

      var fecha_end = this.order_pdf.end_date.split(' ');
      var he = fecha_end[1];

      console.log('ORDEN -> ' + JSON.stringify(this.order_pdf));

      // Replace Order number //
      html_template = html_template.replace('{0}', this.order_pdf.order_number);
      // Replace Order Customer Name //
      html_template = html_template.replace('{1}', this.order_pdf.customer_name);
      // Replace Order Address //
      html_template = html_template.replace('{2}', this.order_pdf.address_checkIn);
      // Replace Order CheckIn Date //
      html_template = html_template.replace('{3}', hi);
      //html_template = html_template.replace(new RegExp('{3}', 'g'), this.order.start_date);
      // Replace Order CheckOut Date //
      html_template = html_template.replace('{4}', he);
      // Replace Order Materiales //
      html_template = html_template.replace('{5}', template_materiales);
      // Replace Order Photo Evidence //
      html_template = html_template.replace('{6}', template_evidencias);

      //if(this.my_evidencia != undefined && this.my_evidencia != null){
         // Replace Evidencia Description //
         //html_template = html_template.replace('{7}', this.my_evidencia.description);
      //}
     
      // Replace Evidencia Firma //
      //html_template = html_template.replace('{8}', this.url_firma);
      // Replace Nombre del firmante //
      //html_template = html_template.replace('{9}', this.customer_name_signature);
      // Replace Nombre de la orden o actividad //
      html_template = html_template.replace('{10}', this.order_pdf.order_name);
      // Replace Address CheckIn //
      html_template = html_template.replace('{11}', this.order_pdf.address_checkIn);
      // Replace Usuario //
      html_template = html_template.replace('{12}', this.order_pdf.user_name);
      // Replace URL MAP //
      html_template = html_template.replace('{13}', this.url_map);
      // Replace Fecha //
      html_template = html_template.replace('{14}', fecha);
      // Replace Order Duration //
      html_template = html_template.replace('{15}', this.toDuration(this.order_pdf.start_date, this.order_pdf.end_date));
      // Replace Logo Client //
      var logo = '<img src= "' + this.authService.customerSelected.url_logo + '" id="img_logo">';
      html_template = html_template.replace('{16}', logo);
      // Replace URL_PDF //
      html_template = html_template.replace('{17}', this.url_link);
      
      this.template = html_template;
     
        console.log('NEW TEMPLATE -> ' + this.template);

      resolve(true);

    });
  }
  */
  toDuration(start_date: string, end_date: string) {
    let start_moment = Moment(start_date),
      end_moment = Moment(end_date);

    if (!end_moment.isValid() || !start_moment.isValid()) return "0 minutes";

    let total_minutes = 78; // end_moment.diff(start_moment, 'minutes');

    let secs = end_moment.diff(start_moment, "seconds");
    var hours = Math.floor(secs / (60 * 60));

    var divisor_for_minutes = secs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);

    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);

    var obj = {
      h: hours || 0,
      m: minutes || 0,
      s: seconds || 0,
    };

    return (
      (obj.h > 0 ? `${obj.h} hours ` : "") +
      (obj.m > 0 ? `${obj.m} minutes ` : "") +
      (obj.s > 0 ? `${obj.s} seconds` : "")
    );
  }
}
